/* Source: /app/components/ui/Panel.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { cn } from "../../lib/utils.js";
import { Play, Copy, Check, Code2, FileCode, FileOutput } from "lucide-react";
import { useState } from "@jac/runtime";
function Panel(props) {
  let title = (props.title || "");
  let subtitle = (props.subtitle || "");
  let className = (props.className || "");
  let headerClassName = (props.headerClassName || "");
  let children = props.children;
  let onRun = props.onRun;
  let onCopy = props.onCopy;
  let codeValue = (props.codeValue || "");
  let icon = props.icon;
  let envReady = (props.envReady || false);
  const [copied, setCopied] = useState(false);
  function handleCopy() {
    if (codeValue) {
      navigator.clipboard.writeText(codeValue);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
    if (onCopy) {
      onCopy();
    }
  }
  function getIcon() {
    if (icon) {
      return icon;
    }
    if (title.includes("Input")) {
      return __jacJsx(FileCode, {"className": "w-4 h-4 text-primary"}, []);
    }
    if (title.includes("Output")) {
      return __jacJsx(FileOutput, {"className": "w-4 h-4 text-primary"}, []);
    }
    return __jacJsx(Code2, {"className": "w-4 h-4 text-primary"}, []);
  }
  return __jacJsx("div", {"className": cn("flex flex-col h-full bg-surface border border-border rounded-lg overflow-hidden", className)}, [__jacJsx("div", {"className": cn("h-9 px-3 flex items-center justify-between border-b border-border bg-surface-hover", headerClassName)}, [__jacJsx("div", {"className": "flex items-center gap-2"}, [getIcon(), __jacJsx("span", {"className": "text-xs font-medium text-text-primary"}, [title])]), __jacJsx("div", {"className": "flex items-center gap-1"}, [(props.showActions && __jacJsx(null, {}, [__jacJsx("button", {"onClick": () => {
    onRun(props.title);
  }, "disabled": !envReady, "className": cn("p-1.5 rounded transition-colors", ((!envReady && "text-text-secondary opacity-50 cursor-not-allowed") || "hover:bg-surface text-text-secondary hover:text-text-primary")), "title": ((envReady && "Run Code") || "Environment loading...")}, [__jacJsx(Play, {"className": "w-3.5 h-3.5"}, [])]), __jacJsx("button", {"onClick": handleCopy, "className": "p-1.5 hover:bg-surface rounded text-text-secondary hover:text-text-primary transition-colors", "title": ((copied && "Copied!") || "Copy Code")}, [(copied && __jacJsx(Check, {"className": "w-3.5 h-3.5 text-success"}, [])), (!copied && __jacJsx(Copy, {"className": "w-3.5 h-3.5"}, []))])])), ((!props.showActions && subtitle) && __jacJsx("span", {"className": "text-xs text-text-secondary"}, [subtitle]))])]), __jacJsx("div", {"className": "flex-1 overflow-auto"}, [children])]);
}
export {Panel};